interface FiltrosState {
  coops: Array<string>;
  colaborador?: boolean;
  cpfOrNome: string;
  data: string;
  dataHasError: boolean;
}

type FiltrosActionTypes = 'setCoops' | 'setColaborador' | 'setSearch' | 'setData' | 'setDataError';

interface FiltrosAction {
  type: FiltrosActionTypes;
  value: any;
}

export const filtrosInitialState: FiltrosState = {
  coops: [],
  cpfOrNome: '',
  data: '',
  dataHasError: false,
};

export const filtrosReducer = (state: FiltrosState, action: FiltrosAction): FiltrosState => {
  switch (action.type) {
    case 'setCoops':
      return { ...state, coops: action.value };
    case 'setColaborador':
      return { ...state, colaborador: action.value };
    case 'setData':
      return { ...state, data: action.value };
    case 'setSearch':
      return { ...state, cpfOrNome: action.value };
    case 'setDataError':
      return { ...state, dataHasError: action.value };
    default:
      return state;
  }
};
